import datepicker from 'js-datepicker';
import formatDate from '../../utils/date';

import Form from '../_form';

export default class JobProposeForm extends Form {

    /* eslint-disable no-useless-constructor */
    constructor (query) {
        super(query);

        this.setDatepicker();

        this.setTimepicker();

        this.updateDisabled();
    }

    setDatepicker () {
        const field = this.form.querySelector('#execution-date');
        if (!field) return;

        const today = new Date();

        const maxDateString = field.dataset.max;
        const [maxDay, maxMonth, maxYear] = maxDateString.split('.');

        datepicker('#execution-date', {
            minDate: today,
            maxDate: new Date(`${maxYear}-${maxMonth}-${maxDay}`),
            onSelect: () => field.dispatchEvent(new Event('input')),
            formatter: (input, date) => {
                const parsed = date.toLocaleString('en-GB', { timeZone: 'UTC' }).split(',')[0];
                const formatted = parsed.split('/').reverse().join('-');

                const value = formatDate(formatted, 'MMMM d, yyyy');

                input.value = value
            },
            onShow: () => field.classList.add('triggered'),
            onHide: () => field.classList.remove('triggered')
        });
    }

    setTimepicker () {
        const field = this.form.querySelector('#execution-time');
        if (!field) return;

        const window = this.form.querySelector('#time-window');
        if (!window) return;

        const controls = {
            hours: {
                data: [],
                field: this.form.querySelector('#time-hours'),
                up: this.form.querySelector('#time-hours-up'),
                down: this.form.querySelector('#time-hours-down')
            },
            minutes: {
                data: [],
                field: this.form.querySelector('#time-minutes'),
                up: this.form.querySelector('#time-minutes-up'),
                down: this.form.querySelector('#time-minutes-down')
            },
            selection: {
                fieldAM: this.form.querySelector('#time-selection-am'),
                fieldPM: this.form.querySelector('#time-selection-pm'),
                value: new FormData(this.form).get('time-selection')
            }
        };

        for (let i = 1; i <= 12; i++) {
            const value = i < 10 ? `0${i}` : i;

            controls.hours.data.push(value);
        }

        for (let i = 0; i <= 55; i += 5) {
            const value = i < 10 ? `0${i}` : i;

            controls.minutes.data.push(value);
        }

        let hdi = 0;

        controls.hours.up.addEventListener('click', (event) => {
            event.stopPropagation();

            if (hdi + 1 < controls.hours.data.length) { hdi++; } else { hdi = 0; }

            controls.hours.field.value = controls.hours.data[hdi];

            controls.hours.field.dispatchEvent(new Event('change'));
        });

        controls.hours.down.addEventListener('click', (event) => {
            event.stopPropagation();

            if (hdi - 1 >= 0) { hdi--; } else { hdi = controls.hours.data.length - 1; }

            controls.hours.field.value = controls.hours.data[hdi];

            controls.hours.field.dispatchEvent(new Event('change'));
        });

        let mdi = 0;

        controls.minutes.up.addEventListener('click', (event) => {
            event.stopPropagation();

            if (mdi + 1 < controls.minutes.data.length) { mdi++; } else { mdi = 0; }

            controls.minutes.field.value = controls.minutes.data[mdi];

            controls.hours.field.dispatchEvent(new Event('change'));
        });

        controls.minutes.down.addEventListener('click', (event) => {
            event.stopPropagation();

            if (mdi - 1 >= 0) { mdi--; } else { mdi = controls.minutes.data.length - 1; }

            controls.minutes.field.value = controls.minutes.data[mdi];

            controls.hours.field.dispatchEvent(new Event('change'));
        });

        [controls.hours.field, controls.minutes.field].forEach((subfield) => {
            subfield.addEventListener('change', () => {
                field.value = `${controls.hours.field.value}:${controls.minutes.field.value} ${controls.selection.value}`;

                field.dispatchEvent(new Event('input'));
            });
        });

        [controls.selection.fieldAM, controls.selection.fieldPM].forEach((subfield) => {
            subfield.addEventListener('change', () => {
                controls.selection.value = new FormData(this.form).get('time-selection');

                field.value = `${controls.hours.field.value}:${controls.minutes.field.value} ${controls.selection.value}`;

                field.dispatchEvent(new Event('input'));
            });
        });

        document.documentElement.addEventListener('click', () => {
            field.classList.remove('triggered');
            field.parentNode.parentNode.classList.remove('triggered');
        });

        field.addEventListener('click', (event) => {
            event.stopPropagation();

            field.classList.toggle('triggered');
            field.parentNode.parentNode.classList.toggle('triggered');

            field.value = `${controls.hours.field.value}:${controls.minutes.field.value} ${controls.selection.value}`;
        });

        window.addEventListener('click', (event) => {
            event.stopPropagation();

            field.classList.add('triggered');
            field.parentNode.parentNode.classList.add('triggered');
        });
    }

    updateDisabled () {
        const checkbox = this.form.querySelector('input[type="checkbox"]');

        checkbox.addEventListener('change', (e) => {
            e.stopPropagation();

            if (checkbox.checked) {
                this.submit.removeAttribute('disabled');
            } else {
                this.submit.setAttribute('disabled', '');
            }
        });
    }

    async finalizeForm () {
        if (this.submit) this.submit.classList.add('preload');

        const formData = new FormData(this.form);

        const price = formData.get('price');
        const date = formData.get('execution-date');
        const time = formData.get('execution-time');
        const details = formData.get('details');

        try {
            await fetch('/wp-json/jobs/v1/propose', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ price, date, time, details })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.form.classList.remove('error');
                    this.form.classList.add('sent');

                    this.NotificationManager.sendNotification('success', 'Proposal sent!', data.message);

                    if (data.url) {
                        setTimeout(() => window.location.href = data.url, 3000);
                    }

                    if (this.submit) this.submit.classList.remove('preload');
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.form.classList.add('error');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                if (this.submit) this.submit.classList.remove('preload');

                this.form.classList.add('error');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

            if (this.submit) this.submit.classList.remove('preload');

            this.form.classList.add('error');
        }
    }
}
